import { errorCodeOf } from "@/shared/api/error-code";
import { ApiError } from "@/shared/api/http-client";

export type OrganizationsErrorKind = "notFound" | "forbidden" | "rateLimited" | "generic";

const ORGANIZATION_NOT_FOUND = "ORGANIZATION_NOT_FOUND";

/**
 * What went wrong with an admin organizations read, never the server message
 * (the responses name people). A 404 only means "no such organization" when
 * the API says so with its error code: a bare 404 is a route that does not
 * exist (an API older than A20) and must not read as a deleted organization.
 */
export function organizationsErrorKind(error: unknown): OrganizationsErrorKind {
  if (error instanceof ApiError) {
    if (error.status === 404 && errorCodeOf(error) === ORGANIZATION_NOT_FOUND) return "notFound";
    if (error.status === 403) return "forbidden";
    if (error.status === 429) return "rateLimited";
  }
  return "generic";
}
